export const offerLandingConstants = {
    GET_OFFER_LANDING_PENDING  : 'GET_OFFER_LANDING_PENDING',
    GET_OFFER_LANDING_FULFILLED: 'GET_OFFER_LANDING_FULFILLED',
    GET_OFFER_LANDING_REJECTED : 'GET_OFFER_LANDING_REJECTED',
}
